import apiClient from "./apiClient";
import { defineStore } from "pinia";
import {
    DurationTimeType,
    EducationalType,
    Kato, LocalityType, OwnershipType, RegionGroup, RegionType, TimesheetType,
} from "@/types/kindergarten";
import {ref} from "vue";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;
const BASE_URL_KINDERGARTEN = `${BASE_URL}/api/v1/kindergarten`;
const KATO_LIST_URL = `${BASE_URL_KINDERGARTEN}/kato`;
const REGION_GROUP_LIST_URL = `${BASE_URL_KINDERGARTEN}/region/group`;
const REGION_TYPE_LIST_URL = `${BASE_URL_KINDERGARTEN}/region/type`;
const LOCALITY_TYPE_LIST_URL = `${BASE_URL_KINDERGARTEN}/locality/type`;
const EDUCATIONAL_TYPE_LIST_URL = `${BASE_URL_KINDERGARTEN}/educational/type`;
const DURATION_TYPE_LIST_URL = `${BASE_URL_KINDERGARTEN}/duration/time`;
const OWNERSHIP_TYPE_LIST_URL = `${BASE_URL_KINDERGARTEN}/ownership/type`;
const TIMESHEET_TYPE_LIST_URL = `${BASE_URL_KINDERGARTEN}/timesheet/type`;

const useKatoStore = defineStore("kato", () => {
    const katoList = ref<Kato[]>([]);
    const fetchKato = async () => {
        const cachedKato = localStorage.getItem("katoList");
        if (cachedKato) {
            katoList.value = JSON.parse(cachedKato);
            return katoList.value;
        }
        try {
            const response = await apiClient.get<Kato[]>(KATO_LIST_URL);
            katoList.value = response.data;
            localStorage.setItem("katoList", JSON.stringify(katoList.value));
            return katoList.value;
        } catch (error) {
            console.error("Ошибка при загрузке Kato:", error);
            throw error;
        }
    };
    const refreshKato = async () => {
        try {
            const response = await apiClient.get<Kato[]>(KATO_LIST_URL);
            katoList.value = response.data;
            localStorage.setItem("katoList", JSON.stringify(katoList.value));
        } catch (error) {
            console.error("Ошибка при обновлении Kato:", error);
            throw error;
        }
    };
    return {
        katoList,
        fetchKato,
        refreshKato,
    };
});


const useRegionGroup = defineStore("regionGroup",  () => {
    const regionGroupList = ref<RegionGroup[]>([]);
    const fetchRegionGroup = async () => {
        const cachedRegionGroup = localStorage.getItem("regionGroupList");
        if (cachedRegionGroup) {
            regionGroupList.value = JSON.parse(cachedRegionGroup);
            return regionGroupList.value;
        }
        try {
            const response = await apiClient.get<RegionGroup[]>(REGION_GROUP_LIST_URL);
            regionGroupList.value = response.data;
            localStorage.setItem("regionGroupList", JSON.stringify(regionGroupList.value));
            return regionGroupList.value;
        } catch (error) {
            console.log("Ошибка при загрузке RegionGroup:", error)
            throw error;
        }
    };
    const refreshRegionGroup = async () => {
        try {
            const response = await apiClient.get<RegionGroup[]>(REGION_GROUP_LIST_URL);
            regionGroupList.value = response.data;
            localStorage.setItem("regionGroupList", JSON.stringify(regionGroupList.value));
        } catch (error) {
            console.log("Ошибка при загрузке RegionGroup:", error)
            throw error;
        }
    };
    return {
        regionGroupList,
        fetchRegionGroup,
        refreshRegionGroup,
    }
});

const useOwnershipType = defineStore("ownershipType", () => {
    const ownershipList = ref<OwnershipType[]>([]);
    const fetchOwnershipType = async () => {
        const cachedOwnership = localStorage.getItem("ownershipList");
        if (cachedOwnership) {
            ownershipList.value = JSON.parse(cachedOwnership);
            return ownershipList.value;
        }
        try {
            const response = await apiClient.get<OwnershipType[]>(OWNERSHIP_TYPE_LIST_URL);
            ownershipList.value = response.data;
            localStorage.setItem("ownershipList", JSON.stringify(ownershipList.value));
            return ownershipList.value;
        } catch (error) {
            console.log("Ошибка при загрузке OwnershipType:", error)
            throw error;
        }
    };
    const refreshOwnershipType = async () => {
        try {
            const response = await apiClient.get<OwnershipType[]>(OWNERSHIP_TYPE_LIST_URL);
            ownershipList.value = response.data;
            localStorage.setItem("ownershipList", JSON.stringify(ownershipList.value));
        } catch (error) {
            console.log("Ошибка при загрузке OwnershipType:", error)
            throw error;
        }
    }
    return {
        ownershipList,
        fetchOwnershipType,
        refreshOwnershipType
    }
});

const useRegionType = defineStore("regionType", () => {
    const regionTypeList = ref<RegionType[]>([]);
    const fetchRegionType = async () => {
        const cachedRegionTypeList = localStorage.getItem("regionTypeList");
        if (cachedRegionTypeList) {
            regionTypeList.value = JSON.parse(cachedRegionTypeList);
            return regionTypeList.value;
        }
        try {
            const response = await apiClient.get<RegionType[]>(REGION_TYPE_LIST_URL);
            regionTypeList.value = response.data;
            localStorage.setItem("regionTypeList", JSON.stringify(regionTypeList.value));
            return regionTypeList.value;
        } catch (error) {
            console.log("Ошибка при загрузке RegionType:", error)
            throw error;
        }
    };
    const refreshRegionType = async () => {
        try {
            const response = await apiClient.get<RegionType[]>(REGION_TYPE_LIST_URL);
            regionTypeList.value = response.data;
            localStorage.setItem("regionTypeList", JSON.stringify(regionTypeList.value));
        } catch (error) {
            console.log("Ошибка при загрузке RegionType:", error)
            throw error;
        }
    };
    return {
        regionTypeList,
        fetchRegionType,
        refreshRegionType
    }
});

const useLocalityType = defineStore("localityType", () => {
    const localityTypeList = ref<LocalityType[]>([]);
    const fetchLocalityType = async () => {
        const cachedLocalityTypeList = localStorage.getItem("localityTypeList");
        if (cachedLocalityTypeList) {
            localityTypeList.value = JSON.parse(cachedLocalityTypeList);
            return localityTypeList.value;
        }
        try {
            const response = await apiClient.get<LocalityType[]>(LOCALITY_TYPE_LIST_URL);
            localityTypeList.value = response.data;
            localStorage.setItem("localityTypeList", JSON.stringify(localityTypeList.value));
            return localityTypeList.value;
        } catch (error) {
            console.log("Ошибка при загрузке LocalityType:", error)
            throw error;
        }
    };
    const refreshLocalityType = async () => {
        try {
            const response = await apiClient.get<LocalityType[]>(LOCALITY_TYPE_LIST_URL);
            localityTypeList.value = response.data;
            localStorage.setItem("localityTypeList", JSON.stringify(localityTypeList.value));
        } catch (error) {
            console.log("Ошибка при загрузке LocalityType:", error)
            throw error;
        }
    };
    return {
        localityTypeList,
        fetchLocalityType,
        refreshLocalityType,
    }
});

const useEducationalType = defineStore("educationalType", () => {
    const educationalTypeList = ref<EducationalType[]>([]);
    const fetchEducationalType = async () => {
        const cachedEducationalTypeList = localStorage.getItem("educationalTypeList");
        if (cachedEducationalTypeList) {
            educationalTypeList.value = JSON.parse(cachedEducationalTypeList);
            return educationalTypeList.value;
        }
        try {
            const response = await apiClient.get<EducationalType[]>(EDUCATIONAL_TYPE_LIST_URL);
            educationalTypeList.value = response.data;
            localStorage.setItem("educationalTypeList", JSON.stringify(educationalTypeList.value));
            return educationalTypeList.value;
        } catch (error) {
            console.log("Ошибка при загрузке LocalityType:", error)
            throw error;
        }
    };
    const refreshEducationalType = async () => {
        try {
            const response = await apiClient.get<EducationalType[]>(EDUCATIONAL_TYPE_LIST_URL);
            educationalTypeList.value = response.data;
            localStorage.setItem("educationalTypeList", JSON.stringify(educationalTypeList.value));
        } catch (error) {
            console.log("Ошибка при загрузке LocalityType:", error)
            throw error;
        }
    }
    return {
        educationalTypeList,
        fetchEducationalType,
        refreshEducationalType,
    }
});

const useDurationTime = defineStore("durationTime", () => {
    const durationTimeTypeList = ref<DurationTimeType[]>([]);
    const fetchDurationTime = async () => {
        const cachedDurationTimeList = localStorage.getItem("durationTimeType");
        if (cachedDurationTimeList) {
            durationTimeTypeList.value = JSON.parse(cachedDurationTimeList);
            return durationTimeTypeList.value;
        }
        try  {
            const response = await apiClient.get<DurationTimeType[]>(DURATION_TYPE_LIST_URL);
            durationTimeTypeList.value = response.data;
            localStorage.setItem("durationTimeType", JSON.stringify(durationTimeTypeList.value));
            return durationTimeTypeList.value;
        } catch (error) {
            console.log("Ошибка при загрузке LocalityType:", error)
            throw error;
        }
    };
    const refreshDurationTime = async () => {
        try  {
            const response = await apiClient.get<DurationTimeType[]>(DURATION_TYPE_LIST_URL);
            durationTimeTypeList.value = response.data;
            localStorage.setItem("durationTimeType", JSON.stringify(durationTimeTypeList.value));
        } catch (error) {
            console.log("Ошибка при загрузке LocalityType:", error)
            throw error;
        }
    }
    return {
        durationTimeTypeList,
        fetchDurationTime,
        refreshDurationTime,
    }
});

const useTimesheetType = defineStore("timesheetType", () => {
    const timesheetTypeList = ref<TimesheetType[]>([]);
    const fetchTimesheetType = async () => {
        const cachedTimesheetTypeList = localStorage.getItem("timesheetType");
        if (cachedTimesheetTypeList) {
            timesheetTypeList.value = JSON.parse(cachedTimesheetTypeList);
            return timesheetTypeList.value;
        }
        try  {
            const response = await apiClient.get<TimesheetType[]>(TIMESHEET_TYPE_LIST_URL);
            timesheetTypeList.value = response.data;
            localStorage.setItem("timesheetType", JSON.stringify(timesheetTypeList.value));
            return timesheetTypeList.value;
        } catch (error) {
            console.log("Ошибка при загрузке TimesheetType:", error)
            throw error;
        }
    };
    const refreshTimesheetType = async () => {
        try  {
            const response = await apiClient.get<TimesheetType[]>(TIMESHEET_TYPE_LIST_URL);
            timesheetTypeList.value = response.data;
            localStorage.setItem("timesheetType", JSON.stringify(timesheetTypeList.value));
        } catch (error) {
            console.log("Ошибка при загрузке TimesheetType:", error)
            throw error;
        }
    }
    return {
        timesheetTypeList,
        fetchTimesheetType,
        refreshTimesheetType,
    }
});

export default {
    useKatoStore,
    useRegionType,
    useRegionGroup,
    useLocalityType,
    useOwnershipType,
    useEducationalType,
    useDurationTime,
    useTimesheetType,
}